module.exports = __webpack_public_path__ + "img/ts8.86e5450f.png";